import { render, staticRenderFns } from "./sub_list.vue?vue&type=template&id=07c1441a&"
import script from "./sub_list.vue?vue&type=script&lang=js&"
export * from "./sub_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07c1441a')) {
      api.createRecord('07c1441a', component.options)
    } else {
      api.reload('07c1441a', component.options)
    }
    module.hot.accept("./sub_list.vue?vue&type=template&id=07c1441a&", function () {
      api.rerender('07c1441a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/customer_information/form/sub_list.vue"
export default component.exports